// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3zB5S","content":"styles_content__2RzjM","checkbox":"styles_checkbox__2VpCq","checkboxLabel":"styles_checkboxLabel__2ICSF"};